module.exports = __webpack_public_path__ + "img/arrow-reload-horizontal-sharp.455abf1b.svg";